import { render, staticRenderFns } from "./ImgCheckbox.vue?vue&type=template&id=c5ba7a68&scoped=true"
import script from "./ImgCheckbox.vue?vue&type=script&lang=js"
export * from "./ImgCheckbox.vue?vue&type=script&lang=js"
import style0 from "./ImgCheckbox.vue?vue&type=style&index=0&id=c5ba7a68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ba7a68",
  null
  
)

export default component.exports